module.exports = __webpack_public_path__ + "img/8.618875d3.png";